module.exports = __webpack_public_path__ + "01d17076b9e89b06f0065547ccc1b3fe.pdf";